import { valueEmpty } from 'helpers';
import { TOP_MAKES } from 'components/forms/boat/constants';

export const years = () => {
  const year = new Date().getFullYear();
  return Array.from(new Array(60), (v, i) => ({
    value: (year - i).toString(),
    label: (year - i).toString(),
  }));
};

const titleCaseWords = (string: string) =>
  !valueEmpty(string)
    ? string
        .split(/ /g)
        .map((word) => `${word.substring(0, 1).toUpperCase()}${word.substring(1).toLowerCase()}`)
        .join(' ')
    : '';

export const renderLabel = (label: string) => {
  const labelFormat = titleCaseWords(label).replace(/\/[a-z]/g, (match) => match.replace('/', ' / \n').toUpperCase());
  const upperCaseAcronyms = labelFormat.replace(/(?:Usa|Mb|HP|hp|Hp)/g, (match) => match.toUpperCase());
  const labelToRender = upperCaseAcronyms.replace(/(?:'[a-z]|’[a-z])/g, (match) => `${match} \n`);
  return labelToRender;
};

export const topMakes = () =>
  Array.from(TOP_MAKES, (v) => ({
    value: renderLabel(v),
    label: renderLabel(v),
    group: 'Top Makes',
  }));
